import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lightbulb, Loader2, Check, Trash2, TrendingUp, Award } from "lucide-react";
import { api } from "../../lib/api";

export default function ImprovementsTab({ offerId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => api.listImprovements(offerId).then(setItems).catch(() => {});
  useEffect(() => { load(); }, [offerId]);

  const generate = async () => {
    setLoading(true);
    try {
      await api.genImprovements(offerId);
      toast.success("Proposte generate");
      load();
    } catch {
      toast.error("Errore nella generazione");
    } finally {
      setLoading(false);
    }
  };

  const toggle = async (id) => { await api.toggleImprovement(id); load(); };
  const del = async (id) => { await api.deleteImprovement(id); load(); };

  return (
    <div className="space-y-5 fade-up">
      <div className="bg-white border border-slate-200 rounded-xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center shrink-0">
          <Lightbulb className="w-6 h-6 text-amber-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-display font-semibold text-lg text-slate-900">Proposte Tecniche Migliorative AI</h3>
          <p className="text-sm text-slate-500">Varianti migliorative per gare OEV: efficienza energetica, materiali CAM, sicurezza, durabilità. Le proposte incluse finiscono nel PDF di offerta.</p>
        </div>
        <button onClick={generate} disabled={loading} data-testid="ai-propose-improvements-button"
          className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold text-white ${loading ? "bg-amber-400" : "bg-amber-600 hover:bg-amber-700 active:scale-95"}`}>
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lightbulb className="w-4 h-4" />}
          {loading ? "Generazione…" : items.length ? "Genera altre" : "Genera proposte"}
        </button>
      </div>

      {items.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-6">Nessuna proposta ancora generata.</p>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((imp) => (
            <div key={imp.id} data-testid={`improvement-card-${imp.id}`} className={`bg-white border rounded-xl p-5 transition-colors ${imp.included ? "border-emerald-400 ring-1 ring-emerald-200" : "border-slate-200"}`}>
              <div className="flex items-start justify-between gap-2 mb-2">
                <span className="text-[11px] font-semibold px-2 py-1 rounded-md bg-amber-50 text-amber-700 border border-amber-200">{imp.category}</span>
                <div className="flex gap-1">
                  <button onClick={() => toggle(imp.id)} data-testid={`improvement-toggle-${imp.id}`}
                    className={`inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-md border ${imp.included ? "bg-emerald-600 text-white border-emerald-600" : "bg-white text-slate-600 border-slate-200 hover:border-slate-300"}`}>
                    <Check className="w-3.5 h-3.5" /> {imp.included ? "Inclusa" : "Includi in PDF"}
                  </button>
                  <button onClick={() => del(imp.id)} data-testid={`improvement-delete-${imp.id}`} className="p-1.5 rounded-md hover:bg-red-50 text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>
                </div>
              </div>
              <h4 className="font-display font-semibold text-slate-900 leading-snug">{imp.title}</h4>
              <p className="text-sm text-slate-600 mt-1.5">{imp.description}</p>
              <div className="mt-3 pt-3 border-t border-slate-100 grid grid-cols-3 gap-2 text-xs">
                <div><div className="text-slate-400">Impatto costi</div><div className="font-medium text-slate-700">{imp.cost_impact}</div></div>
                <div><div className="text-slate-400 flex items-center gap-1"><TrendingUp className="w-3 h-3" />Benefici</div><div className="font-medium text-slate-700">{imp.savings}</div></div>
                <div><div className="text-slate-400 flex items-center gap-1"><Award className="w-3 h-3" />Punteggio</div><div className="font-medium text-emerald-700">{imp.score_impact}</div></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
